import { DataGrid } from "@mui/x-data-grid";
import { dataGridDefaults } from "../../../../utils/constant";
import useColumnHide, {
  ColumnHiddenMessage,
  getColumnHideConfig,
} from "../../../../hooks/useColumnHide";
import { NoRowsOverlay } from "../../../../components/NoRowsOverlay";
import { CustomPagination } from "../../../../components/CustomPagination";
import useTableColumns from "./helpers/useTableColumns";
import useListMapping from "./helpers/useListMapping";
import LoadingDialog from "../../../../components/LoadingDialog";
import { useReduxContext, setLiquidityProviderParams } from "../reduxContext";
import UpdateExchangeRateDialog from "./UpdateExchangeRateDialog";
import useLiquidityProviderTabQuery from "../useLiquidityProviderTabQuery";

const ViewTable = () => {
  const [state, dispatch] = useReduxContext();
  const { params } = state;

  const { data, isLoading: isTableResLoading } = useLiquidityProviderTabQuery();
  const { rows = [], count = 0 } = data ?? {};

  const listMapping = useListMapping();
  const content = listMapping("key", rows);

  const onPageChange = (page: number) => {
    dispatch(setLiquidityProviderParams({ ...params, page }));
  };

  const { columns } = useTableColumns();

  const { colsShown, setColsShown, hasColHidden, localeText } = useColumnHide(
    columns,
    getColumnHideConfig()
  );

  if (isTableResLoading) return <LoadingDialog forceOpen={true} />;

  return (
    <>
      <ColumnHiddenMessage hasColHidden={hasColHidden} />
      <UpdateExchangeRateDialog />
      <DataGrid
        {...dataGridDefaults}
        localeText={localeText}
        columnVisibilityModel={colsShown}
        onColumnVisibilityModelChange={setColsShown}
        rows={content}
        rowCount={count}
        columns={columns}
        page={params.page}
        onPageChange={onPageChange}
        components={{
          NoRowsOverlay,
          Footer: CustomPagination,
        }}
        componentsProps={{
          footer: { totalRecords: count },
        }}
      />
    </>
  );
};

export default ViewTable;
